/**
 * DownIcon Component
 * 
 * This component renders down Icon for autocomplete field
 * 
 * */
import React from 'react';
import { Icon } from './AutoComplete.styled';
import DownArrowFilter from 'src/assets/images/BaselineKeyboardArrowDown24.svg';

export default function DownIcon(props) {
    const {height, 
            disabled, 
            onChange, 
            onClose,
            readOnly,
            value
            } = props;
    return ( 
        <Icon
        id="autocomplete-down-arrow-icon"
            src={DownArrowFilter}
            height={height || '8px'} 
            onClick={() => {
                (!disabled && !readOnly)
                    ? onChange(
                        value,
                        true
                    )
                    : null;
                // onClose &&
                //     onClose();
            }}
            opacity={
                disabled ? '0.5' : '1'
            }
        /> 
    );
}